module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-center"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Forms Input"), _c('small', [_c('i', {
    staticClass: "ti-heart"
  }), _c('i', {
    staticClass: "ti-export"
  }), _c('i', {
    staticClass: "ti-printer"
  })])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Forms ")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Input")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "ti-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove",
      "data-toggle": "tooltip",
      "title": "Remove"
    }
  }, [_c('i', {
    staticClass: "ti-close"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('h4', [_vm._v("Basic")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "Please input"
    },
    model: {
      value: (_vm.input),
      callback: function($$v) {
        _vm.input = $$v
      },
      expression: "input"
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Disabled")]), _vm._v(" "), _c('p', [_vm._v("Disable the Input with the "), _c('code', [_vm._v("disabled")]), _vm._v(" attribute.")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "Please input",
      "disabled": true
    },
    model: {
      value: (_vm.input1),
      callback: function($$v) {
        _vm.input1 = $$v
      },
      expression: "input1"
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Input with Icon")]), _vm._v(" "), _c('p', [_vm._v("You can add an icon at the end of Input by setting the "), _c('code', [_vm._v("icon")]), _vm._v(" attribute and use "), _c('code', [_vm._v("on-icon-click")]), _vm._v(" hook to complete some work after clicking the icon.")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "Pick a date",
      "icon": "search",
      "on-icon-click": _vm.handleIconClick
    },
    model: {
      value: (_vm.input2),
      callback: function($$v) {
        _vm.input2 = $$v
      },
      expression: "input2"
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Text Area")]), _vm._v(" "), _c('p', [_vm._v("Resizable for entering multiple lines of text information. Add attribute "), _c('code', [_vm._v("type=\"textarea\"")]), _vm._v(" to change "), _c('code', [_vm._v("input")]), _vm._v(" into native "), _c('code', [_vm._v("textarea")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("Control the height by setting the "), _c('code', [_vm._v("rows")]), _vm._v(" prop.")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "Please input"
    },
    model: {
      value: (_vm.textarea),
      callback: function($$v) {
        _vm.textarea = $$v
      },
      expression: "textarea"
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Mixed input")]), _vm._v(" "), _c('p', [_vm._v("Prepend or append an element, generally a label or a button.")]), _vm._v(" "), _c('div', [_c('el-input', {
    attrs: {
      "placeholder": "Please input"
    },
    model: {
      value: (_vm.input3),
      callback: function($$v) {
        _vm.input3 = $$v
      },
      expression: "input3"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("Http://")])], 2)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Please input"
    },
    model: {
      value: (_vm.input4),
      callback: function($$v) {
        _vm.input4 = $$v
      },
      expression: "input4"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v(".com")])], 2)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Please input"
    },
    model: {
      value: (_vm.input5),
      callback: function($$v) {
        _vm.input5 = $$v
      },
      expression: "input5"
    }
  }, [_c('el-select', {
    attrs: {
      "slot": "prepend",
      "placeholder": "Select"
    },
    slot: "prepend",
    model: {
      value: (_vm.select),
      callback: function($$v) {
        _vm.select = $$v
      },
      expression: "select"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Restaurant",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Order No.",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Tel",
      "value": "3"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "search"
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('hr')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "ti-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove",
      "data-toggle": "tooltip",
      "title": "Remove"
    }
  }, [_c('i', {
    staticClass: "ti-close"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('h4', [_vm._v("Input Number")]), _vm._v(" "), _c('p'), _c('p', [_vm._v("Bind a variable to "), _c('code', [_vm._v("v-model")]), _vm._v(" in "), _c('code', [_vm._v("<el-input-number>")]), _vm._v(" element and you are set.")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('el-input-number', {
    attrs: {
      "min": 1,
      "max": 10
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.num1),
      callback: function($$v) {
        _vm.num1 = $$v
      },
      expression: "num1"
    }
  }), _vm._v(" "), _c('el-input-number', {
    attrs: {
      "step": 2
    },
    model: {
      value: (_vm.num3),
      callback: function($$v) {
        _vm.num3 = $$v
      },
      expression: "num3"
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-70672f2a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/form/FormInput.vue
// module id = 1307
// module chunks = 2